export class AnsweringInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get reachedPoints() {
        return this.question.questionScore.reachedPoints;
    }
    set reachedPoints(p) { }
    get isFullyCorrect() {
        return this.reachedPoints === this.question.maxPoints;
    }
    get isAtLeastPartiallyWrong() {
        return this.reachedPoints < this.question.maxPoints;
    }
    get isQuestionCompleted() {
        return !!this.question.answer.completeDate;
    }
}
